module.exports = __webpack_public_path__ + "img/p2.63f43838.jpg";